{
    "addFromLibrary": "Legg til fra bibliotek",
    "uploadFile": "Last opp PDF-fil",
    "name": "Navn",
    "description": "Beskrivelse",
    "actions": "handlinger",
    "attachmentLibrary": "Vedleggsbibliotek",
    "search": "Søk",
    "preview": "Forhåndsvisning",
    "back": "Tilbake",
    "save": "Lagre",
    "moveDown": "Flytt ned",
    "moveUp": "Flytt opp",
    "delete": "Slett",
    "unselectAllAttachments": "Fjern markeringen av alle vedlegg",
    "selectAllAttachments": "Velg alle vedlegg",
    "unselectAttachment": "Fjern markeringen av vedlegg",
    "selectAttachment": "Velg vedlegg",
    "previewAttachment": "Forhåndsvis vedlegg"
}